export default __webpack_public_path__ + "static/media/resources.74b50bbf.png";